/**
 * Magon runtime observability
 *
 * Classifica o contexto da sessão no Microsoft Clarity sem interceptar,
 * cancelar ou ocultar erros do navegador. Isso permite separar falhas reais
 * do tema de ruídos gerados pelas bridges nativas de WebViews.
 */
(function () {
  'use strict';

  var ua = navigator.userAgent || '';
  var provider = /Instagram/i.test(ua)
    ? 'instagram'
    : /(FBAN|FBAV|FB_IAB)/i.test(ua)
      ? 'facebook'
      : /TikTok/i.test(ua)
        ? 'tiktok'
        : 'none';
  var context = provider === 'none' ? 'regular_browser' : 'in_app_webview';
  var pendingTags = [
    ['runtime_context', context],
    ['webview_provider', provider],
    ['theme_runtime', 'magon_v2']
  ];
  var flushTimer = null;
  var flushAttempts = 0;

  function flushTags() {
    if (typeof window.clarity === 'function') {
      pendingTags.splice(0).forEach(function (tag) {
        window.clarity('set', tag[0], tag[1]);
      });
      if (flushTimer) clearInterval(flushTimer);
      flushTimer = null;
      return;
    }
    flushAttempts += 1;
    if (flushAttempts >= 20 && flushTimer) {
      clearInterval(flushTimer);
      flushTimer = null;
    }
  }

  function addTag(key, value) {
    pendingTags.push([key, value]);
    flushTags();
  }

  function classifyError(message, filename) {
    var msg = String(message || '').toLowerCase();
    var file = String(filename || '').toLowerCase();
    if (msg.indexOf('_autofillcallbackhandler') !== -1 || msg.indexOf('webkit.messagehandler') !== -1) {
      return 'webview_native';
    }
    if (msg.indexOf('marketingallowed') !== -1 || msg.indexOf('customerprivacy') !== -1) {
      return 'privacy_integration';
    }
    if (msg.indexOf("module specifier '@theme/") !== -1) {
      return 'theme_importmap';
    }
    if (file.indexOf('/assets/magon-') !== -1 || file.indexOf('/assets/theme') !== -1) {
      return 'theme_asset';
    }
    return 'browser_or_third_party';
  }

  window.addEventListener('error', function (event) {
    addTag('js_error_class', classifyError(event.message, event.filename));
  }, true);

  window.addEventListener('unhandledrejection', function () {
    addTag('js_error_class', 'unhandled_promise');
  });

  flushTags();
  if (pendingTags.length) flushTimer = setInterval(flushTags, 500);
})();
